var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "preview-area" }, [
    _c("div", { staticClass: "preview-step" }, [
      _c("h3", {}, [_vm._v("分享给微信好友")]),
      _c("div", { staticClass: "preview-content preview-friends" }, [
        _c("div", { staticClass: "preview-friends-box" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_setup.previewObj.value.title)),
          ]),
          _c("div", { staticClass: "image" }, [
            _c("img", { attrs: { src: _setup.previewObj.value.image } }),
          ]),
          _c("div", { staticClass: "platform" }, [
            _c("img", { attrs: { src: require("../assets/icon_link.png") } }),
            _c("label", [_vm._v(_vm._s(_setup.previewObj.value.platform))]),
          ]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "preview-step" }, [
      _c("h3", {}, [_vm._v("分享给微信好友-聊天展示")]),
      _c("div", { staticClass: "preview-content preview-chat" }, [
        _c("div", { staticClass: "preview-chat-box" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_setup.previewObj.value.title)),
          ]),
          _c("div", { staticClass: "left" }, [
            _c("div", { staticClass: "content" }, [
              _vm._v(_vm._s(_setup.previewObj.value.content)),
            ]),
          ]),
          _c("div", { staticClass: "image" }, [
            _c("img", { attrs: { src: _setup.previewObj.value.image } }),
          ]),
          _c("div", { staticClass: "platform" }, [
            _c("img", { attrs: { src: require("../assets/icon_link.png") } }),
            _c("label", [_vm._v(_vm._s(_setup.previewObj.value.platform))]),
          ]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "preview-step" }, [
      _c("h3", { on: { click: _setup.increment } }, [_vm._v("分享至朋友圈")]),
      _c("div", { staticClass: "preview-content preview-circle" }, [
        _c("div", { staticClass: "preview-circle-box" }, [
          _c("div", { staticClass: "image" }, [
            _c("img", { attrs: { src: _setup.previewObj.value.image } }),
          ]),
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_setup.previewObj.value.title)),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }